import { Button, Flex, Title } from '@mantine/core';
import { IconAddressBook } from '@tabler/icons-react';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { ROUTES } from 'configs/routes';
import { useDevices } from 'utils/devices';

import Text from '../Text';

import s from './AccreditationBanner.module.scss';

type AccreditationBannerProps = {
  className: string;
};

const AccreditationBanner: React.FC<AccreditationBannerProps> = ({ className }) => {
  const { isPhone } = useDevices();

  return (
    <Flex className={className} p={0} direction="column" align="center">
      <div className={s.iconWrap}>
        <IconAddressBook className={s.icon} size={32} />
      </div>

      <Title c="dark" size={isPhone ? 'h3' : 'h1'} className={s.title}>
        Закончите аккредитацию
      </Title>
      <Text c="dimmed" className={s.desc}>
        Перейдите в профиль компании и закончите аккредитацию
      </Text>
      <Button variant="transparent" size="xm" component={Link} to={ROUTES.lk.profile.create()}>
        Перейти в профиль
      </Button>
    </Flex>
  );
};

export default AccreditationBanner;
